var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
// tslint:disable: no-unbound-method
import { HttpClient } from "@angular/common/http";
import { ConfigureService } from "app/configure/configure.service";
import { GenericService } from "app/shared/generic.service";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
var SplitPaymentsService = /** @class */ (function () {
    function SplitPaymentsService(genericService, config, http) {
        this.genericService = genericService;
        this.config = config;
        this.http = http;
        this.endpoint = "/splitter/payment-groups";
        this.splitPaymentEndpoint = "/splitter/split-payments";
        this.bookingEndpoint = "/bookings";
        this._isSplitPayment = false;
    }
    Object.defineProperty(SplitPaymentsService.prototype, "isSplitPayment", {
        get: function () {
            return this._isSplitPayment;
        },
        set: function (val) {
            this._isSplitPayment = val;
        },
        enumerable: true,
        configurable: true
    });
    SplitPaymentsService.prototype.splitCancellationPolicy = function () {
        return this.cancellationPolicy;
    };
    SplitPaymentsService.prototype.getSplitPaymentPGBookerId = function () {
        return this.splitPaymentPGBookerId;
    };
    SplitPaymentsService.prototype.getUParam = function (u, isFirst) {
        var separator = (isFirst) ? '?' : '&';
        return (u) ? separator + 'u=' + u : '';
    };
    SplitPaymentsService.prototype.getSplitPayments = function (id, u) {
        return this.http.get("" + this.config.params.apiClientUri + this.endpoint + "/" + id + "?include=split-payments" + this.getUParam(u, false), this.genericService.addAuthHeaders()).pipe(catchError(this.genericService.handleError));
    };
    SplitPaymentsService.prototype.paySplitPayment = function (obj, u) {
        return this.http.post("" + this.config.params.apiClientUri + this.endpoint + "/" + obj.data.id + "/pay" + this.getUParam(u, true), { data: obj.data }, { observe: 'response' }).pipe(catchError(this.genericService.handleError));
    };
    SplitPaymentsService.prototype.confirmSplitPayment = function (id, u) {
        var endpoint = this.splitPaymentEndpoint + '/' + id + ("/confirm" + this.getUParam(u, true));
        return this.http.post("" + this.config.params.apiClientUri + endpoint, {}).pipe(catchError(this.genericService.handleError));
    };
    SplitPaymentsService.prototype.getQRCode = function (id, u) {
        var endpoint = this.endpoint + '/' + id + ("/qr" + this.getUParam(u, true));
        return this.http.get("" + this.config.params.apiClientUri + endpoint, __assign({}, this.genericService.addAuthHeaders(), { responseType: 'blob' })).pipe(catchError(this.genericService.handleError));
    };
    SplitPaymentsService.prototype.getCancellationPolicy = function (id, u) {
        var endpoint = this.bookingEndpoint + "/" + id + this.getUParam(u, true);
        return this.http.get("" + this.config.params.apiClientUri + endpoint, {}).pipe(catchError(this.genericService.handleError));
    };
    SplitPaymentsService.prototype.cancelBooking = function (id, u, payload) {
        var endpoint = this.bookingEndpoint + '/' + id + '/cancelled' + ("" + this.getUParam(u, true));
        return this.http.post("" + this.config.params.apiClientUri + endpoint, payload, __assign({}, this.genericService.addAuthHeaders())).pipe(catchError(this.genericService.handleError));
    };
    SplitPaymentsService.prototype.cancelSplitPayment = function (id, u, payload) {
        var endpoint = this.splitPaymentEndpoint + '/' + id + ("" + this.getUParam(u, true));
        return this.http.put("" + this.config.params.apiClientUri + endpoint, payload, __assign({}, this.genericService.addAuthHeaders())).pipe(catchError(this.genericService.handleError));
    };
    SplitPaymentsService.prototype.payRemaining = function (id, u, payload) {
        var endpoint = this.endpoint + '/' + id + ("/capture" + this.getUParam(u, true));
        return this.http.post("" + this.config.params.apiClientUri + endpoint, payload, __assign({}, this.genericService.addAuthHeaders())).pipe(catchError(this.genericService.handleError));
    };
    return SplitPaymentsService;
}());
export { SplitPaymentsService };
